import baseAPI from "@/http";

const router = "api/pergunta/perguntapmd";

export const pmdAPI = {
  get: (ids) => baseAPI.get(`${router}/get-pmd?id=${ids}`),
  update: (payload) => baseAPI.put(`${router}/update-pmd`, payload),
};
